import { loadCloserScript } from './script';
import { open, isOpen, isOpened } from './open';
import close from './close';
import update from './update';
import minimize from './minimize';
import maximize from './maximize';
import hide from './hide';
import { reload } from './reload';
import { getDeviceType } from './device';
import { updateUserStatus } from './userStatus';
import { launchQueuedActions } from './events';

const setVariables = () => {
    const [closerOrgId, closerScriptBaseUrl, enableCloserLog] = loadCloserScript();
    window.WC = window.WC || {};
    window.WC.Closer = {
        _onCloseCallback: null,
        _closerOrgId: closerOrgId,
        _closerScriptBaseUrl: closerScriptBaseUrl,
        _isInitialized: false,
        _enableCloserLog: !!enableCloserLog,
        isOpen: isOpen,
        isOpened: isOpened,
        wasOpen: false,
        open: open,
        close: close,
        update: update,
        minimize: minimize,
        maximize: maximize,
        hide: hide,
        device: null
    };

    window.WC.Closer.device = getDeviceType();
};

const initialize = () => {
    updateUserStatus();
    reload();
    launchQueuedActions();
};

setVariables();
initialize();
